import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { defineKey as T } from '@ha/intl';
import { GlobalState } from 'ha/types/store';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { setInStorage } from 'ha/utils/sessionStorage';

import { isLoading } from '../selectors';
import { STORAGE_KEY } from '../constants';

const ERROR_MESSAGE = T(
  'There was an error adding your favorite listing. Please try again later',
);

export enum ActionTypes {
  START = '[favorites] ADD_FAVORITE',
  DONE = '[favorites] ADD_FAVORITE_DONE',
  FAIL = '[favorites] ADD_FAVORITE_FAIL',
}

export const Actions = {
  start: (listingId: number) => createAction(ActionTypes.START, listingId),
  done: (listingId: number) => createAction(ActionTypes.DONE, listingId),
  fail: (listingId: number) => createAction(ActionTypes.FAIL, listingId),
};
export type ActionsType = ActionsUnion<typeof Actions>;

type AddFavoriteListing = (
  listingId: number,
  returnUrl?: string,
) => Thunk<GlobalState>;

const addFavoriteListing: AddFavoriteListing =
  (listingId, returnUrl) =>
  async (dispatch, getState, { apiV2 }) => {
    if (!getIsAuthenticated(getState())) {
      setInStorage(STORAGE_KEY, listingId);

      dispatch(NavBarActions.showModal('register', returnUrl));

      return;
    }

    if (isLoading(getState(), listingId)) {
      return;
    }

    dispatch(Actions.start(listingId));

    try {
      await apiV2.addFavoriteListing(listingId);

      dispatch(Actions.done(listingId));
    } catch (error) {
      reportError('Error adding favourite listing', { metaData: { error } });
      dispatch(
        sendAlert({
          text: ERROR_MESSAGE,
          kind: 'danger',
          dismissAfter: 5000,
        }),
      );
      dispatch(Actions.fail(listingId));
    }
  };

export default addFavoriteListing;
